

import React, { useContext, useEffect, useState } from "react";
import CircularScrollProgress from "../Circularprogress";
import { Link } from 'react-router-dom';
import AuthUser from "../../services/AuthUser";
import { handleRazorpayPayment } from "../../services/handlePayment";
import { ServicesContext } from "../../services/ServicesContext";

import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import { PartenerSheepDeedService } from "../../services/parternshipservice";

import Testimonials from "../Testimonial";

import { HashLink } from 'react-router-hash-link';
import PfEsicPlan from "./PfEsicPlan";



function PfEsicReturn() {

  const [activeQuestion, setActiveQuestion] = useState(null);
  const { http, token } = AuthUser();

  const toggleQuestion = (questionId) => {
    setActiveQuestion((prev) => (prev === questionId ? null : questionId));
  };



const [plans, setPlans] = useState([]);

const [option1Plans, setOption1Plans] = useState([]);
  const [selectedOption, setSelectedOption] = useState("option1");




  const [selecttrue1, setSelectrue1] = useState("");
  const [selecttrue2, setSelectrue2] = useState("");
  const [selecttrue3, setSelectrue3] = useState("");
  const [selecttrue4, setSelectrue4] = useState("");

const handleChange = async (e) => {
  const value = e.target.value;
  setSelectedOption(value);

  // option6 => show form only
  if (value === "option6") {
    setPlans([]);
    return;
  }

  try {
    const response = await http.get("/service-plans", {
      params: {
        service_id: 54,
        group_key: value
      }
    });

    if (response.data.success) {
      setPlans(response.data.plans);
    } else {
      setPlans([]);
    }
  } catch (error) {
    console.log(error);
    setPlans([]);
  }
};

// useEffect(() => {
//   const loadDefault = async () => {
//     try {
//       const response = await http.get("/service-plans", {
//         params: { service_id: 54, group_key: "option1" }
//       });
//       if (response.data.success) setPlans(response.data.plans);
//     } catch (e) {
//       console.log(e);
//     }
//   };
//   loadDefault();
// }, []);

useEffect(() => {
  const loadDefault = async () => {
    try {
      const response = await http.get("/service-plans", {
        params: {
          service_id: 54,
          group_key: "option1",
        },
      });

      if (response.data.success) {
        setPlans(response.data.plans);
        setOption1Plans(response.data.plans);
      }
    } catch (error) {
      console.log(error);
    }
  };

  loadDefault();
}, []);


const startingPrice = option1Plans.find(
  (plan) =>
    plan.group_key === "option1" &&
    plan.plan_key === "pf"
)?.price;

  const [activeTab, setActiveTab] = useState(1);
  const showContent = (tabId) => {
    setActiveTab(tabId);
  };

  const showInputTag = (value) => {
    if (value === "1") {
      setSelectrue1("1");
    }
    else if (value === "2") {
      setSelectrue2("2");
    }
    else if (value === "3") {
      setSelectrue3("3");
    }
    else if (value === "4") {
      setSelectrue4("4");
    }

  };



  const [isFormVisible, setIsFormVisible] = useState(false);

  const toggleFormVisibility = () => {
    setIsFormVisible(!isFormVisible);
  };

  const basicPlan1 = {
    title: "ESIC",
    price: "1250",
    oldPrice: "1813.00",
    discount: 25,
     requirements: [
    "One-time medical form generation for ESIC",
    "One-time data updation for employees",
    "Monthly Record updation for employees",
    "Monthly Chalan Preparation",
    "Monthly Challan and return submission & payment (on behalf of the client)",
    "Maintain Employee Record",
    "New Employee registration and updation",
    "Medical TIC updation with family details",
    "Employee benefit report as required for medical",
    "RC and Payment confirmation for employers"
  ],

  inclusions: [
    "Dashboard for managing service",
   
    "Documents sharing facility",
    "Download deliverables any time",
    "Password sharing",
    "Round the clock support",
    "Time to time updates & notifications"
  ],
  };
  const basicPlan2 = {
    title: "ESIC",
    price: "2250",
    oldPrice: "2813.00",
    discount: 25,
         requirements: [
    "One-time medical form generation for ESIC",
    "One-time data updation for employees",
    "Monthly Record updation for employees",
    "Monthly Chalan Preparation",
    "Monthly Challan and return submission & payment (on behalf of the client)",
    "Maintain Employee Record",
    "New Employee registration and updation",
    "Medical TIC updation with family details",
    "Employee benefit report as required for medical",
    "RC and Payment confirmation for employers"
  ],

  inclusions: [
    "Dashboard for managing service",
   
    "Documents sharing facility",
    "Download deliverables any time",
    "Password sharing",
    "Round the clock support",
    "Time to time updates & notifications"
  ],
  };
  const basicPlan3 = {
    title: "ESIC",
    price: "3250",
    oldPrice: "3813.00",
    discount: 25,
       requirements: [
    "One-time medical form generation for ESIC",
    "One-time data updation for employees",
    "Monthly Record updation for employees",
    "Monthly Chalan Preparation",
    "Monthly Challan and return submission & payment (on behalf of the client)",
    "Maintain Employee Record",
    "New Employee registration and updation",
    "Medical TIC updation with family details",
    "Employee benefit report as required for medical",
    "RC and Payment confirmation for employers"
  ],

  inclusions: [
    "Dashboard for managing service",
   
    "Documents sharing facility",
    "Download deliverables any time",
    "Password sharing",
    "Round the clock support",
    "Time to time updates & notifications"
  ],
  };
  const basicPlan4 = {
    title: "ESIC",
    price: "4250",
    oldPrice: "4813.00",
    discount: 25,
        requirements: [
    "One-time medical form generation for ESIC",
    "One-time data updation for employees",
    "Monthly Record updation for employees",
    "Monthly Chalan Preparation",
    "Monthly Challan and return submission & payment (on behalf of the client)",
    "Maintain Employee Record",
    "New Employee registration and updation",
    "Medical TIC updation with family details",
    "Employee benefit report as required for medical",
    "RC and Payment confirmation for employers"
  ],

  inclusions: [
    "Dashboard for managing service",
   
    "Documents sharing facility",
    "Download deliverables any time",
    "Password sharing",
    "Round the clock support",
    "Time to time updates & notifications"
  ],
  };
  const basicPlan5 = {
    title: "ESIC",
    price: "5250",
    oldPrice: "5813.00",
    discount: 25,
        requirements: [
    "One-time medical form generation for ESIC",
    "One-time data updation for employees",
    "Monthly Record updation for employees",
    "Monthly Chalan Preparation",
    "Monthly Challan and return submission & payment (on behalf of the client)",
    "Maintain Employee Record",
    "New Employee registration and updation",
    "Medical TIC updation with family details",
    "Employee benefit report as required for medical",
    "RC and Payment confirmation for employers"
  ],

  inclusions: [
    "Dashboard for managing service",
   
    "Documents sharing facility",
    "Download deliverables any time",
    "Password sharing",
    "Round the clock support",
    "Time to time updates & notifications"
  ],
  };

  const starterPlan1 = {
    title: "PF",
    price: "3250",
    oldPrice: "4063.75",
    discount: 25,
  requirements : [
  "Form 5A Submission",
  "One-time employee detail updation",
  "One-time data updation for employee",
  "UAN Number allocation/updation",
  "Monthly Record updation for employees",
  "Monthly ECR Working",
  "Monthly Challan Preparation",
  "Monthly Challan and return submission & payment (on behalf of the client)",
  "Updation for challan submission & payment confirmation",
  "Digital Signature Uploading/Verification Returns"
],

inclusions : [
  "Dashboard for managing service",
 
  "Documents sharing facility",
  "Download deliverables any time",
  "Password sharing",
  "Round the clock support",
  "Time to time updates & notifications"
],
  };


  const starterPlan2 = {

    title: "PF",
    price: "7250",
    oldPrice: "9063.00",
    discount: 25,
requirements : [
  "Form 5A Submission",
  "One-time employee detail updation",
  "One-time data updation for employee",
  "UAN Number allocation/updation",
  "Monthly Record updation for employees",
  "Monthly ECR Working",
  "Monthly Challan Preparation",
  "Monthly Challan and return submission & payment (on behalf of the client)",
  "Updation for challan submission & payment confirmation",
  "Digital Signature Uploading/Verification Returns"
],

inclusions : [
  "Dashboard for managing service",
 
  "Documents sharing facility",
  "Download deliverables any time",
  "Password sharing",
  "Round the clock support",
  "Time to time updates & notifications"
],
  };
  const starterPlan3 = {

    title: "PF",
    price: "12250",
    oldPrice: "15313.75.00",
    discount: 25,
  requirements : [
  "Form 5A Submission",
  "One-time employee detail updation",
  "One-time data updation for employee",
  "UAN Number allocation/updation",
  "Monthly Record updation for employees",
  "Monthly ECR Working",
  "Monthly Challan Preparation",
  "Monthly Challan and return submission & payment (on behalf of the client)",
  "Updation for challan submission & payment confirmation",
  "Digital Signature Uploading/Verification Returns"
],

inclusions : [
  "Dashboard for managing service",
 
  "Documents sharing facility",
  "Download deliverables any time",
  "Password sharing",
  "Round the clock support",
  "Time to time updates & notifications"
],
  };
  const starterPlan4 = {

    title: "PF",
    price: "24250",
    oldPrice: "30313.75.00",
    discount: 25,
requirements : [
  "Form 5A Submission",
  "One-time employee detail updation",
  "One-time data updation for employee",
  "UAN Number allocation/updation",
  "Monthly Record updation for employees",
  "Monthly ECR Working",
  "Monthly Challan Preparation",
  "Monthly Challan and return submission & payment (on behalf of the client)",
  "Updation for challan submission & payment confirmation",
  "Digital Signature Uploading/Verification Returns"
],

inclusions : [
  "Dashboard for managing service",
 
  "Documents sharing facility",
  "Download deliverables any time",
  "Password sharing",
  "Round the clock support",
  "Time to time updates & notifications"
],
  };
  const starterPlan5 = {

    title: "PF",
    price: "36250",
    oldPrice: "45313.75.00",
    discount: 25,
 requirements : [
  "Form 5A Submission",
  "One-time employee detail updation",
  "One-time data updation for employee",
  "UAN Number allocation/updation",
  "Monthly Record updation for employees",
  "Monthly ECR Working",
  "Monthly Challan Preparation",
  "Monthly Challan and return submission & payment (on behalf of the client)",
  "Updation for challan submission & payment confirmation",
  "Digital Signature Uploading/Verification Returns"
],

inclusions : [
  "Dashboard for managing service",
 
  "Documents sharing facility",
  "Download deliverables any time",
  "Password sharing",
  "Round the clock support",
  "Time to time updates & notifications"
],
  };

  const [newData, setNewData] = useState({ user_name: '', user_designation: '', user_email: '', user_contact: '', user_related_query: '' })


  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!newData.user_name.trim()) {
      newErrors.user_name = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }
    if (!newData.user_designation.trim()) {
      newErrors.user_designation = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_designation)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }

    if (!newData.user_email.trim()) {
      newErrors.user_email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }

    if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }

    if (!newData.user_related_query) {
      newErrors.user_related_query = 'This field required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // No errors
  };





  const formPutPartenshipdeed = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    await handleRazorpayPayment({
      service,
      userData: newData,
      http, // ✅ Pass this from the component
      fieldMap: {
        email: newData.user_email ? 'user_email' : 'user_email_address',
        contact: newData.user_contact ? 'user_contact' : 'user_phone_number',
        name: newData.user_name ? 'user_name' : 'full_name'
      }
      ,
      formSubmitCallback: async (mergedData) => {
        await PartenerSheepDeedService.pfEsicReturn(mergedData);
        setNewData({
          user_name: '',
          user_email: '',
          user_contact: '',
          user_related_query: '',
          user_designation: '',
        });
      },
    });

  };


  const [receivedData, setReceivedData] = useState(null);

  const handleDataFromChild = (data) => {
    console.log("Data received from child:", data);
    setReceivedData(data);
  };

  const { services, loading, error } = useContext(ServicesContext);
  //  if (loading) {
  //     return <div>Loading...</div>;  // Show loading state while fetching data
  // }

  // if (error) {
  //      return <div>{error}</div> // Show error state if there was an issue fetching data
  // }
  const service = services.find(s => s.service_id === 54);

  const faqs = [
    {
      question: "Who needs to file PF and ESIC returns?",
      answer: "PF returns are mandatory for establishments with 20 or more employees registered under the EPF Act, while ESIC returns apply to establishments with 10 or more employees earning wages up to ₹21,000 per month under the ESIC Act."
    },
    {
      question: "What are the contribution rates for PF and ESIC?",
      answer: "For PF, both employer and employee contribute 12% of the employee's basic salary. For ESIC, the employer contributes 3.25% and the employee contributes 0.75% of the wages."
    },
    {
      question: "When are PF and ESIC returns due?",
      answer: "PF returns are filed monthly by the 15th of the following month and annually by 30th April. ESIC monthly contributions are due by the 15th, with half-yearly returns due by 11th November and 12th May."
    },
    {
      question: "What documents are required for PF and ESIC return filing?",
      answer: "Documents typically required include employee details, wage information, previous contribution challans, and registration certificates."
    },
    {
      question: "What happens if I file returns late?",
      answer: "Late filing of PF and ESIC returns may attract penalties and interest charges as per applicable laws."
    },
    {
      question: "Can your experts help with the entire PF and ESIC return filing process?",
      answer: "Yes, our team handles document verification, data collection, return filing, and keeps you updated throughout the process."
    },
    {
      question: "Are PF and ESIC returns filed online?",
      answer: "Yes, returns for both PF and ESIC are filed through their respective official government portals."
    },
    {
      question: "Can I modify submitted documents if there is an error?",
      answer: "You can update or correct documents before final submission; post-submission changes may require additional procedures."
    },
    {
      question: "Is filing PF and ESIC returns mandatory?",
      answer: "Yes, compliance with PF and ESIC regulations is mandatory for applicable establishments under respective laws."
    },
    {
      question: "Do you provide assistance with penalties and compliance issues?",
      answer: "We provide guidance to avoid penalties and ensure compliance but recommend consulting legal professionals for complex disputes."
    }
  ];

const handleBannerClick = () => {
  const scrollToElement = document.querySelector(".price-heading");
 

  // 1️⃣ Scroll to .price-heading
  if (scrollToElement) {
    scrollToElement.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }

};

  return (
    <>

       <div className="hero-section">
       <div className="container">
         <div className="row hero-row">
     
           <div className="col-lg-8 hero-left">
                    <div class="title title2">
                 <h1 class="sk-text-color">PF & ESIC Return Filing</h1>
     
     
<p className="pdrl-text">
  Start with Only{" "}
  <span className="text-color">
    {startingPrice != null
      ? `₹${Number(startingPrice).toLocaleString("en-IN")}/-`
      : "Loading..."}
  </span>
</p>            
     
              <p className="pd-text">
               Dm2Legal provides expert assistance in managing both PF and ESIC return filings, ensuring compliance with Indian labor laws and avoiding potential penalties. 
               Here's how we streamline the process for you:
             </p>
     
             <div className="btn-group">
                                                 <Link to="/contactus" className="theme-btn-3 btn-color ">
                                                     Schedule A Call <span><i className="fa-solid fa-arrow-right"></i></span>
                                                 </Link>
                             </div>
                             <div className="space30"></div>
     
             {/* <div className="hero-link">
               <a href="/gst-registration">PF & ESIC Return Filing</a>
             </div> */}
             <div className="banner" onClick={handleBannerClick}>
                                <img src="assets/icons/banner.svg" alt="" />
                             </div>
                             </div>
           </div>
     
           <div className="col-lg-4 hero-right">
              <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" /> 
             <img src="assets/img/images/girl3.png" alt="PF & ESIC Return Filing" />
           </div>
     
         </div>
       </div>
     </div>
     

      <div className="space80"></div>





      <div className="home4-counters bg-white">
        <div className="space50"></div>
        <div className="container">
          <div className="row about" id="abouttds">

            <div className="col-lg-12">

              <h2>PF Return Filing</h2>

              <p className="pd-text">Provident Fund (PF) return filing is mandatory for establishments with 20 or more employees or those that have voluntarily registered under the Employees’ Provident Funds and Miscellaneous Provisions Act, 1952. Both the employer and employee contribute 12% of the employee’s basic salary to the EPF account. These contributions are crucial for ensuring employee financial security post-retirement.

              </p>
              <p className="pd-text">
                PF returns are filed on a monthly and annual basis. Monthly returns must be submitted by the 15th of the following month, while annual returns are due by the 30th of April each year. The process involves collecting employee details and salary information, generating the Electronic Challan cum Return (ECR) file, uploading it on the EPFO portal, generating and finalizing the challan, and making the payment online. Failure to file on time may attract penalties and interest, making it essential for employers to ensure timely and accurate submissions.
              </p>
              <h2>ESIC  Return Filing</h2>

              <p className="pd-text">
                ESIC (Employees’ State Insurance Corporation) return filing applies to establishments with 10 or more employees who earn up to ₹21,000 per month, under the Employees’ State Insurance Act, 1948. The employee contributes 0.75% of their wages, while the employer contributes 3.25%. These contributions provide employees with essential medical and financial benefits during illness, maternity, disability, or employment injury.
              </p>
              <p className="pd-text">
                Monthly ESIC contributions must be deposited by the 15th of the following month. Additionally, employers are required to submit half-yearly returns—one for the period from April to September (due by 11th November), and another for October to March (due by 12th May). The return filing process includes logging into the ESIC portal, entering employee and wage details, generating the challan, completing the online payment, and submitting the return. Late filing or payment can result in interest charges and penalties, emphasizing the importance of timely compliance.                            </p>
            </div>
            {/* <div className="col-lg-4">

                            <div className="contact6-list doc-list">
                                <img src="assets/img/images/About-TDS-Return-Filing.png" alt="" />
                            </div>
                        </div> */}
          </div>
          <div className="space40"></div>
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">

                <h2 className="aos-init aos-animate text-center">Plans</h2>
              </div>
              <p className="pd-text text-center">Please Select the Number of Employees</p>
              <div className="price-heading">

                <select id="dropdown" class="selectturnover" onChange={handleChange}>
                  <option value="option1">01 to 20 Employees</option>
                  <option value="option2">21 to 40 Employees</option>
                  <option value="option3">41 to 75 Employees</option>
                  <option value="option4">76 to 100 Employees</option>
                  <option value="option5">101 to 150 Employees</option>
                  <option value="option6">Above 150 Employees</option>
                  {/* <option value="option7">Nill Return</option> */}
                </select>
              </div>
              &nbsp;
              {selectedOption !== "option6" && (
  <div className="box-container">
    <div className="container">
      <div className="row box-center">
        {plans.map((plan) => (
          <div className="col-md-3 col-sm-6" key={plan.id}>
            <PfEsicPlan
              title={plan.title}
              price={parseFloat(plan.price)}
              oldPrice={plan.meta?.oldPrice}
              discount={plan.meta?.discount}
              requirements={plan.meta?.requirements || []}
              inclusions={plan.meta?.inclusions || []}
              onSubmit={handleDataFromChild}
            />
          </div>
        ))}
      </div>
    </div>
  </div>
)}


              {selectedOption === "option6" && (<div className="box-container" id="option5-boxes">
                <div className="container">
                  <div className="row box-center">
                    <div className="col-md-3 col-sm-6">
                      <div className="pricing-plan">
                        <p className="pp-text">Enterprise Solution</p>
                        <div className="formContainer ">
                          <form>
                            <div className="form-group">
                              <input type="text" className="form-control" placeholder="Contact Person Name"
                                required value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                              {errors.user_name && <p className="error">{errors.user_name}</p>}
                            </div>
                            <div className="form-group">
                              <input type="text" className="form-control" placeholder="Contact Person Designation" required value={newData.user_designation} onChange={(e) => setNewData({ ...newData, user_designation: e.target.value })} />
                              {errors.user_designation && <p className="error">{errors.user_designation}</p>}
                            </div>
                            <div className="form-group">
                              <input type="email" className="form-control" placeholder="Email" required value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                              {errors.user_email && <p className="error">{errors.user_email}</p>}
                            </div>
                            <div className="form-group">
                              <input type="tel" className="form-control" placeholder="Contact No." required value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
                              {errors.user_contact && <p className="error">{errors.user_contact}</p>}
                            </div>
                            <div className="form-group">
                              <input type="text" className="form-control"
                                placeholder="Tentative Parties Quarterly" required onChange={(e) => setNewData({ ...newData, user_related_query: e.target.value })} value={newData.user_related_query} />
                              {errors.user_related_query && <p className="error">{errors.user_related_query}</p>}
                            </div>
                            <button type="submit" className="getStartedBtn btn btn-light" onClick={formPutPartenshipdeed}>Submit</button>
                          </form>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>)}
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <h2 className="text-center">How to apply</h2>
                <div className="space30"></div>
                <img src="assets/img/images/legal251-how-to-apply.png" alt="" />
              </div>
            </div>
          </div>
          <div className="space40"></div>
        </div>
      </div>




      <div className="service-binifits9 sp0" id="service2">
        <div className="space50"></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <h2 className="text-center">Types of Employee Provident Fund Return Filing Form</h2>
              </div>
            </div>
            <div className="space40"></div>

            <div className="tabs">
              <div className="tab-row">
                <div
                  className={`tab ${activeTab === 1 ? 'active-tab' : ''}`}
                  onClick={() => showContent(1)}
                >
                  Form 5
                </div>
                <div
                  className={`tab ${activeTab === 2 ? 'active-tab' : ''}`}
                  onClick={() => showContent(2)}
                >
                  Form 10
                </div>
                <div
                  className={`tab ${activeTab === 3 ? 'active-tab' : ''}`}
                  onClick={() => showContent(3)}
                >
                  Form 12A
                </div>
                <div
                  className={`tab ${activeTab === 4 ? 'active-tab' : ''}`}
                  onClick={() => showContent(4)}
                >
                  Form 3A
                </div>
                <div
                  className={`tab ${activeTab === 5 ? 'active-tab' : ''}`}
                  onClick={() => showContent(5)}
                >
                  Form 6A
                </div>
              </div>
            </div>

            <div className="space30"></div>



            <div className="contents">
              {activeTab === 1 && (
                <div className="content" id="content1">
                  <h2>Form 5</h2>
                  <p className="pd-text">Registration of new employees and updating employee details</p>
                </div>
              )}
              {activeTab === 2 && (
                <div className="content" id="content2">
                  <h2>Form 10</h2>
                  <p className="pd-text">Declaration and nomination of beneficiaries by employees

                  </p>
                </div>
              )}
              {activeTab === 3 && (
                <div className="content" id="content3">
                  <h2>Form 12A</h2>
                  <p className="pd-text">Registration of establishments under the EPF scheme.</p>
                </div>
              )}
              {activeTab === 4 && (
                <div className="content" id="content4">
                  <h2>Form 3A</h2>
                  <p className="pd-text">Monthly contribution details of employees</p>
                </div>
              )}
              {activeTab === 5 && (
                <div className="content" id="content5">
                  <h2>Form 6A</h2>
                  <p className="pd-text">Annual contribution details of employees.</p>
                </div>
              )}
            </div>
            <div className="space80"></div>
          </div>

        </div>
      </div>

      <div className="service-binifits9 " id="">
        <div className="container work8">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">Documents Required for PF & ESIC Return Filing</h2>
                <div className="space10"></div>
                <p className="pd-text text-center">To ensure smooth and accurate filing of PF and ESIC returns, the following documents are typically required:</p>
              </div>
            </div>
            <div className="col-lg-6 d-flex align-items-center justify-content-center">
              <div className="contact6-list doc-list">
                <img src="assets/img/images/Documents-Required-for-GST-Return-Filing.png" alt="" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="single-price ">
                <div className="price-heading">
                  <h3 className="text-center">Documents List</h3>
                </div>
                <div className="price-body">
                  <ul>
                    <h3>Company Documents:</h3>
                    <ul>
                      <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Certificate of Incorporation</li>
                      <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Company PAN Card</li>
                      <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; GST Certificate (if applicable)</li>
                    </ul>
                    <div className="space20"></div>
                    <h3>Employee Details:</h3>
                    <ul>
                      <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; List of Employees with basic info</li>
                      <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhaar and PAN of Employees</li>
                      <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Bank Account Details</li>
                    </ul>
                    <div className="space20"></div>
                    <h3>Salary & Attendance Records:</h3>
                    <ul>
                      <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Monthly Salary Sheet / Payroll</li>
                      <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Attendance Register</li>
                    </ul>
                    <div className="space20"></div>
                    <h3>Registration & Portal Access:</h3>
                    <ul>
                      <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; PF Establishment Code & Credentials</li>
                      <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; ESIC Employer Code & Credentials</li>
                    </ul>
                    <div className="space20"></div>
                    <h3>Payment & Previous Filings:</h3>
                    <ul>
                      <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Previous ECR Files (PF)</li>
                      <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Paid Challans (PF & ESIC)</li>
                    </ul>
                    <div className="space20"></div>
                    <h3>Others:</h3>
                    <ul>
                      <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Digital Signature Certificate (if required)</li>
                    </ul>
                  </ul>
                </div>
              </div>
            </div>
            <div className="space30"></div>
          </div>


        </div>
      </div>




      <div className="service-binifits9 sp0">
        <div className="space40"></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <h2 className="text-center">Benefits of PF & ESIC Return Filing </h2>
                <div className="service-binifits-boxs">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="single-boxs bg-box">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong> Legal Compliance </strong></p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs bg-box">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> <strong>Employee Welfare</strong>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs bg-box">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> <strong>Business Credibility</strong></p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs bg-box">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> <strong>Access to Employee Benefits</strong></p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs bg-box">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> <strong>Hassle-Free Audits</strong>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs bg-box">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> <strong>Financial Planning and Transparency
                          </strong></p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs bg-box">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> <strong>Avoid Business Disruptions</strong>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs bg-box">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> <strong>Enhances Employer Reputation</strong>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs bg-box">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> <strong>Seamlessness in
                            Transactions</strong></p>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div className="space30"></div>
          </div>
        </div>
      </div>
      <div className="space20"></div>


    <div className="service-binifits9" id="service-due-dates">
  <div className="container work8">
    <div className="row">
      <div className="col-lg-12">
        <div className="hadding7 text-center py-4">
          <h2>Due Dates for PF & ESIC Return Filing</h2>
          <p className="pd-text fs-5 text-center">
            Avoid penalties by filing your PF and ESIC returns on time as per the schedule below.
          </p>
        </div>
      </div>

      <div className="col-lg-12 mb-4">
        <div className="single-price border p-4 shadow-sm bg-box1">
          <div className="text-center mb-3">
            <h3 style={{ fontSize: '2rem' }}>Timely Filing of ESIC Returns</h3>
          </div>
          <div>
            <p className="pd-text fs-5">
              To avoid penalties, employers must file ESIC returns within the prescribed timelines.
              Contributions must be deposited by the <strong>15th of every month</strong> in an authorized bank.
            </p>
            <p className="pd-text fs-5">
              In addition to monthly payments, ESIC also requires <strong>half-yearly return filings</strong>:
            </p>
            <ul className="pd-text ps-4 fs-5 custom-list-arrow">
              <li>
                <span>
                  <img className="arow me-2" src="assets/image/arow-01.svg" alt="arrow" />
                </span>
                <strong>April to September</strong>: File by <strong>November 12th</strong>
              </li>
              <li>
                <span>
                  <img className="arow me-2" src="assets/image/arow-01.svg" alt="arrow" />
                </span>
                <strong>October to March</strong>: File by <strong>May 12th</strong>
              </li>
            </ul>
            <p className="pd-text fs-5">
              Adhering to these deadlines ensures compliance with ESIC regulations and prevents legal or financial consequences.
            </p>
          </div>
        </div>
      </div>

      <div className="col-lg-12 mb-4">
        <div className="single-price border p-4 shadow-sm bg-box1">
          <div className="text-center mb-3">
          <h3 style={{ fontSize: '2rem' }}>PF Return Filing Due Dates</h3>
          </div>
          <div>
            <p className="pd-text fs-5">
              The due dates for filing Provident Fund (PF) returns vary based on the type of establishment. Timely compliance is essential to avoid penalties.
            </p>

            <h5 className="mt-3">Private Establishments:</h5>
            <ul className="pd-text ps-4 fs-5 custom-list-arrow">
              <li>
                <span>
                  <img className="arow me-2" src="assets/image/arow-01.svg" alt="arrow" />
                </span>
                PF returns must be submitted <strong>monthly</strong>.
              </li>
              <li>
                <span>
                  <img className="arow me-2" src="assets/image/arow-01.svg" alt="arrow" />
                </span>
                The deadline is the <strong>15th of the following month</strong>.
              </li>
              <li>
                <span>
                  <img className="arow me-2" src="assets/image/arow-01.svg" alt="arrow" />
                </span>
                Example: For January, the return is due by <strong>February 15th</strong>.
              </li>
            </ul>

            <h5 className="mt-3">Government Establishments:</h5>
            <ul className="pd-text ps-4 fs-5 custom-list-arrow">
              <li>
                <span>
                  <img className="arow me-2" src="assets/image/arow-01.svg" alt="arrow" />
                </span>
                PF returns are submitted on a <strong>quarterly</strong> basis.
              </li>
              <li>
                <span>
                  <img className="arow me-2" src="assets/image/arow-01.svg" alt="arrow" />
                </span>
                Returns must be filed by the end of the month <strong>following the quarter's end</strong>.
              </li>
              <li>
                <span>
                  <img className="arow me-2" src="assets/image/arow-01.svg" alt="arrow" />
                </span>
                Example: For a quarter ending March 31st, returns must be filed by <strong>April 30th</strong>.
              </li>
            </ul>

            <h5 className="mt-3">Quick Overview of Due Dates:</h5>
            <ul className="pd-text ps-4 fs-5 custom-list-arrow">
              <li>
                <span>
                  <img className="arow me-2" src="assets/image/arow-01.svg" alt="arrow" />
                </span>
                <strong>PF Payment:</strong> On or before the <strong>15th of every month</strong>
              </li>
              <li>
                <span>
                  <img className="arow me-2" src="assets/image/arow-01.svg" alt="arrow" />
                </span>
                <strong>PF Annual Return:</strong> Due by <strong>April 25th</strong> each year
              </li>
            </ul>

            <p className="pd-text fs-5">
              Missing these deadlines may result in penalties and legal consequences. Ensure timely filing to stay compliant with PF regulations.
            </p>
          </div>
        </div>
      </div>

      <div className="space40"></div>
    </div>
  </div>
</div>




      <div className="service-binifits9 sp0 last-section " id="service2">
        <div className="space50"></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 ">
              <div className="hadding7">
                <h2 className="text-center">Process for PF & ESIC Return Filing</h2>
                <div className="partnership-deade-section">
                  <div className="space40"></div>
                  <ul className="disc-list">
                    <li><h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                      <span>Our team thoroughly reviews the documents you provide for both PF and ESIC return filing, checking for any errors or missing information to ensure a hassle-free process.</span>
                      <svg className="pointer">
                        <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                      </svg>
                    </li>
                    <li>
                      <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                      <span>Experienced professionals take charge of managing all your document requirements, ensuring that every detail related to PF and ESIC returns is handled accurately.</span>
                      <svg className="pointer">
                        <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                      </svg>
                    </li>
                    <li><h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                      <span>Based on your inputs, we collect and organize all necessary employee and wage data, including contributions, to prepare for accurate return submission.</span>
                      <svg className="pointer">
                        <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                      </svg>
                    </li>
                    <li><h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                      <span>Once the data is verified, our experts file your PF and ESIC returns on the respective government portals, ensuring compliance with all statutory deadlines.</span>
                      <svg className="pointer">
                        <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                      </svg>
                    </li>
                    <li><h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                      <span>After successful filing, we keep you updated and provide confirmation on the status of your PF and ESIC returns for your peace of mind.</span>
                      <svg className="pointer">
                        <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                      </svg>
                    </li>
                  </ul>

                </div>
              </div>
            </div>
            <div className="space80"></div>
          </div>

        </div>
      </div>






      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="faq-items" id="masonry-grid">
              <div className="mesonry-item general single-price-list">
                <div className="faqs inner-faq">
                  <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                  <div className="space30"></div>

                  <div id="general">

                    {faqs.map((faq, index) => (
                      <div className="single-faq" key={index}>
                        <h2
                          className={`faq-heading font-f-3 weight-700 ${activeQuestion === index ? '' : 'collapsed'}`}
                          id={`faq-heading${index}`}
                          onClick={() => toggleQuestion(index)}
                        >
                          Q{index + 1}: {faq.question}
                          <span>
                            {activeQuestion === index ? (
                              <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="collapse icon" />
                            ) : (
                              <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="expand icon" />
                            )}
                          </span>
                        </h2>
                        <div
                          id={`collapse${index}`}
                          className={`accordion-collapse collapse ${activeQuestion === index ? 'show' : ''}`}
                        >
                          <p className="font-f-3 weight-500">{faq.answer}</p>
                        </div>
                      </div>
                    ))}




                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="space30"></div>
        <Testimonials />
      </div>


      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto text-center">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate">Why Choose Us?</h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>1</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                  <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>2</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                  <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>3</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                  <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>4</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                  <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>5</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                  <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>6</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                  <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="space80"></div>
      <WhatsAppScrollButton />

      <Footer />

      <CircularScrollProgress />

    </>
  );
}
export default PfEsicReturn;
